<template>
  <div class="bookConfirmOrder">
    <!-- <Head :title="title"></Head> -->
    <!-- 主题部分 -->
    <div class="content">
      <!-- 商品名称 -->
      <div class="commodity_name">
        <div class="title">{{ skuData.shopsName }}</div>
        <div class="contents">
          <div class="commodity_name_left">
            <img :src="skuData.pictureUrl" alt="" />
          </div>
          <div class="commodity_name_right">
            <p>{{ skuData.meetingTitle }}</p>
            <div class="introduction">
              <div class="details">{{ skuData.selectedText }}</div>
              <div class="number">×{{ skuData.selectedNum }}</div>
            </div>
            <p class="no-refund" v-if="skuData.isRefund === 0">
              当前会议不支持退款
            </p>
            <div class="price">¥{{ totalPrice }}</div>
          </div>
        </div>
      </div>
      <!-- 报名人信息 -->
      <div class="meeting-member">
        <span class="title">参会人</span>
        <div @click="$router.go(-1)">
          <span>{{ signUpData.meetingMemberList[0].name }}，等</span>
          <span>{{ skuData.selectedNum }}人</span>
        </div>
      </div>
      <div class="order-remark">
        <van-cell
          title="订单备注"
          is-link
          :value="remark !== '' ? remark : '无备注'"
          :value-class="remark !== '' ? 'cell-value' : ''"
          @click="openPopup('remark')"
        />
        <van-cell
          title="发票"
          is-link
          :value="
            userInvoiceInfo.invoiceHeader
              ? userInvoiceInfo.invoiceHeader
              : '不开发票'
          "
          value-class="cell-value"
          @click="toInvoice()"
        />
      </div>
      <!-- 支付方式 -->
      <div class="payment" v-if="Number(totalPrice) > 0">
        <div class="title">支付方式</div>
        <div>
          <van-radio-group v-model="radio" direction="horizontal">
            <div class="option">
              <div class="zhifubao">
                <img src="@/assets/mylogin/zhifubao-logo.png" alt="" />
                <span class="option_name">支付宝</span>
              </div>
              <van-radio name="1"></van-radio>
            </div>

            <div class="option">
              <div class="weixin">
                <img src="@/assets/mylogin/weixinzhifu2@2x.png" alt="" />
                <span class="option_name">微信支付</span>
              </div>
              <van-radio name="2"></van-radio>
            </div>
          </van-radio-group>
        </div>
      </div>
      <van-action-sheet v-model="remarkPopupShow" title="备注">
        <div class="popup-content">
          <van-field
            @focus="handleElemInView"
            class="popup-input popup-textarea"
            v-model="remarkPopup"
            rows="8"
            type="textarea"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
          />
          <van-button class="popup-btn" type="default" @click="confirmRemark()"
            >确定</van-button
          >
        </div>
      </van-action-sheet>
      <!-- 底部按钮 -->
      <div class="submit">
        <div class="money">¥{{ totalPrice }}</div>
        <van-button
          type="info"
          class="obt"
          @click="signUp"
          :disabled="btnDisabled"
          >提交订单</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Head from "@/views/mobileView/My/components/headTabs.vue";
export default {
  name: "meetingOrdeyPay",
  components: {
    // Head,
  },
  computed: {
    totalPrice() {
      return (
        (
          (this.skuData.skuPrice * 100 * this.skuData.selectedNum) /
          100
        ).toFixed(2) + ""
      );
    },
  },
  data() {
    return {
      title: "确认订单",
      radio: "1",
      skuData: {
        pictureUrl: "",
        meetingTitle: "",
        meetingId: "",
        selectedNum: 1,
        selectedText: "",
        price: "",
        stock_num: null,
        // 是否需要审核
        isExamine: null,
        // 报名表单配置项
        signUps: [],
        id: "",
        shopsName: "",
      },
      signUpData: {},
      /*
      information: {
        monographName: "",
        pictureUrl: "",
        selectedNum: "",
        selectedText: "",
        skuPrice: "",
        shopsName: "",
      },
      */
      // 接口数据
      Address: {
        provinceName: "",
        cityName: "",
        districtName: "",
        detailAddress: "",
        consignee: "",
        phone: "",
        sysUserAddressId: "",
      },
      // sessionStorage里数据
      address: {
        provinceName: "",
        cityName: "",
        districtName: "",
        detailAddress: "",
        consignee: "",
        phone: "",
        sysUserAddressId: "",
      },
      confirmList: [],
      // 生成订单的id
      payBatchId: "",
      btnDisabled: false, // 提交订单时禁用按钮，防止快速点击产生多比订单
      timer: null,
      // 订单备注系列参数
      remark: "",
      remarkPopupShow: false,
      remarkPopup: "",
      userInvoiceInfo: {},
    };
  },
  created() {
    document.title = this.title;
    this.userInvoiceInfo = sessionStorage.getItem("userInvoiceInfo")
      ? JSON.parse(sessionStorage.getItem("userInvoiceInfo"))
      : {};
    // 获取SKU数据
    if (
      sessionStorage.getItem("skuData") &&
      sessionStorage.getItem("signUpData")
    ) {
      this.skuData = JSON.parse(sessionStorage.getItem("skuData"));
      this.signUpData = JSON.parse(sessionStorage.getItem("signUpData"));
    } else {
      this.$toast.fail("订单已失效，请重新选择");
      // 返回上一页
      setTimeout(this.$router.go(-1), 2200);
    }
  },
  methods: {
    toInvoice() {
      let query = {
        from: "orderConfirm",
      };
      this.$router.push({ path: "/invoice", query });
    },
    // 提交报名表单
    signUp() {
      if (JSON.parse(sessionStorage.getItem("signUpData"))) {
        this.btnDisabled = true;
        // 不需要审核的会议直接支付
        let signUpData = this.signUpData;
        if (this.remark !== "") signUpData.remark = this.remark;
        if (sessionStorage.getItem("userInvoiceInfo")) {
          let userInvoiceInfo = JSON.parse(
            sessionStorage.getItem("userInvoiceInfo")
          );
          let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          userInvoiceInfo.invoicePrice = this.totalPrice;
          userInvoiceInfo.userId = userInfo.user.id;
          signUpData.userInvoiceInfo = userInvoiceInfo;
        }
        this.$apis.goodsServe.meetingMemberSignUp(signUpData).then((res) => {
          // 不需要审核的会议，提交报名人信息，返回订单编号
          if (res.resultCode == 200) {
            this.payBatchId = res.data.payBatchid;
            if (res.data.payStatus == 0) {
              // 免费商品，不需要调支付接口，直接生成订单跳转订单列表或者详情
              this.$router.push({ path: "/orders" });
            } else {
              this.$router.replace({
                path: "/orderDetails",
                query: {
                  id: res.data.payBatchid,
                  isPrimaryOrder: true,
                  payType: this.radio,
                },
              });
            }
          } else {
            this.$toast(res.resultDesc);
            this.btnDisabled = false;
          }
        });
      } else {
        this.$toast.fail("会议信息已失效，请重新选择");
        // 返回上一页
        setTimeout(this.$router.go(-2), 2200);
      }
    },
    // 打开填写信息弹窗
    openPopup(name) {
      this[`${name}Popup`] = this[name];
      this[`${name}PopupShow`] = true;
    },
    // 备注弹窗确认
    confirmRemark() {
      this.remark = this.remarkPopup;
      this.remarkPopupShow = false;
    },
    // 生成订单 -会议的生成订单由后台调用
    async generate() {
      let listObj = {
        id: this.skuData.id,
        num: this.skuData.selectedNum,
      };
      if (this.skuData.promoterId) list.promoterId = this.skuData.promoterId;
      let paramsObj = {
        list: [listObj],
        originProject: "information",
      };
      if (this.remark !== "") obj.remark = this.remark;
      const resp = await this.$apis.paymentServe.generate(paramsObj);
      if (resp.resultCode === "200") {
        this.payBatchId = resp.data.payBatchid;
        if (resp.data.payStatus == 0) {
          // 免费商品，不需要调支付接口，直接生成订单跳转订单列表或者详情
          this.$router.replace({ path: "/orders" });
        } else {
          this.$router.replace({
            path: "/orderDetails",
            query: {
              id: resp.data.payBatchid,
              isPrimaryOrder: true,
              payType: this.radio,
              createTime: resp.data.createTime,
            },
          });
          // // 付费商品，根据支付方式唤起银联支付
          // if (this.radio == "1") {
          //   this.zhifubaoGetPay();
          // } else {
          //   this.weixinGetPay();
          // }
        }
      } else {
        Toast(resp.resultDesc);
      }
    },
    // 银联支付宝
    async zhifubaoGetPay() {
      const resp = await this.$apis.paymentServe.getPay({
        payBatchId: this.payBatchId,
        payType: "h5_ali",
      });
      if (resp.resultCode === "200") {
        location.href = resp.data;
        this.timer = setTimeout(() => {
          this.btnDisabled = false;
        }, 3000);
      } else {
        this.btnDisabled = false;
      }
    },
    // 银联微信接口
    async weixinGetPay() {
      const resp = await this.$apis.paymentServe.getPay({
        merAppId: this.$global.zhifu,
        payBatchId: this.payBatchId,
        payType: "h5_wx",
        sceneType: this.$global.isAndroid_ios() ? "IOS_WAP" : "AND_WAP",
      });
      if (resp.resultCode === "200") {
        location.href = resp.data;
        this.timer = setTimeout(() => {
          this.btnDisabled = false;
        }, 3000);
      } else {
        this.btnDisabled = false;
      }
    },
    // 确保输入框不被软键盘遮挡 处理ios16问题
    handleElemInView(e) {
      window.scrollTo(0, window.innerHeight - 375);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === "meetingDetails" ||
      to.name === "tobepaid" ||
      to.name === "orders"
    ) {
      sessionStorage.removeItem("skuData");
      sessionStorage.removeItem("meetingMemberList");
      sessionStorage.removeItem("periodicalForm");
      sessionStorage.removeItem("signUpData");
      sessionStorage.removeItem("userInvoiceInfo");
      //清除定时器
      clearInterval(this.timer);
      this.timer = null;
    }
    next();
  },
};
</script>

<style lang="scss" scoped>
.bookConfirmOrder {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;

  .content {
    padding: 12px;

    .content_address {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;
      display: flex;
      height: 103px;

      .content_address_left {
        width: 320px;

        .address {
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
          }
        }

        h3 {
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
          margin-top: 6px;
        }

        h4 {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          margin-top: 6px;
        }
      }

      .icon {
        padding-top: 27px;

        img {
          width: 5px;
          height: 9px;
        }
      }
    }

    .content_noaddress {
      margin-bottom: 15px;
    }

    .commodity_name {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;
      // height: 145px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .contents {
        display: flex;
        margin-top: 15px;

        .commodity_name_left {
          width: 80px;
          height: 80px;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .commodity_name_right {
          margin-left: 10px;
          margin-right: 10px;
          overflow: hidden;
          text-overflow: ellipsis;

          p {
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 23px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .introduction {
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 21px;

            .details {
              flex: none;
              width: 200px;
              // -webkit-line-clamp CSS 属性可以把块容器中的内容限制为指定的行数。只有在 display 属性设置成 -webkit-box 或者 -webkit-inline-box 并且 box-orient 属性设置成 vertical时才有效果
              -webkit-line-clamp: 2;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              overflow: hidden;
            }
          }
          .no-refund {
            margin-top: 8px;
            font-size: 12px;
            color: red;
          }

          .price {
            margin-top: 8px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 17px;
          }
        }
      }
    }

    // 参会人
    .meeting-member {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      padding: 10px;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
    }

    .order-remark {
      margin-top: 12px;
      padding: 5px 0;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;

      .cell-value {
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .payment {
      margin-top: 12px;
      padding: 12px;
      background: #fff;
      border-radius: 8px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .option {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 80px;

        ::v-deep.van-radio__icon--checked .van-icon {
          background-color: #4a79f1;
          border-color: #4a79f1;
        }

        .zhifubao {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }

        .weixin {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .submit {
      width: 100%;
      margin: 0px;
      position: fixed;
      left: 0;
      bottom: 0px;
      height: 49px;
      background: #fff;
      display: flex;

      align-items: center;
      justify-content: flex-start;
      padding: 0 10px;

      .money {
        font-size: 21px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff3d3d;
        line-height: 17px;
        width: 190px;
      }

      .obt {
        width: 160px;
        height: 44px;
        border-radius: 22px;
      }
    }
  }

  .popup-content {
    margin: 25px 25px 5px;

    .popup-input {
      margin-bottom: 55px;
      background-color: #f5f5f5;
      border-radius: 8px;
    }

    .popup-textarea {
      margin-bottom: 19px;
    }

    .popup-btn {
      width: 100%;
      height: 44px;
      background-color: #4a79f1;
      border-radius: 22px;
      font-size: 16px;
      color: #ffffff;
      line-height: 44px;
    }
  }
}
</style>
